import { render, staticRenderFns } from "./Order_step.vue?vue&type=template&id=a21f770a&"
import script from "./Order_step.vue?vue&type=script&lang=js&"
export * from "./Order_step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports